// extracted by css-extract-rspack-plugin
export default {"input":"input-ljTbfh input-SH4T1H"};